import { createContext, SetStateAction, useContext, useState } from "react";
import { OneTimePass } from "@/features/accounts/payment/scraping/services/register-accounts-model";


interface OneTimePassContextType {
  count: number;
  oneTimePass: OneTimePass | undefined; // 送られてきたOTPの内、現在設定されているOTP
  oneTimePassList: OneTimePass[]; // 送られてきたOTPのリスト(MAX-Size:3)
  sessionKey: string | undefined;
  otpInfo: string | undefined;
  setCount: React.Dispatch<SetStateAction<number>>;
  setOneTimePass: React.Dispatch<SetStateAction<OneTimePass | undefined>>;
  setOneTimePassList: React.Dispatch<SetStateAction<OneTimePass[]>>;
  setSessionKey: React.Dispatch<SetStateAction<string | undefined>>;
  setOtpInfo: React.Dispatch<SetStateAction<string | undefined>>;
  resetOtpContext: () => void;
}

const OneTimePassContext = createContext<OneTimePassContextType | undefined>(undefined);

export const OneTimePassProvider = ({children}: {children: React.ReactNode}) => {
  const [count, setCount] = useState(0);
  const [oneTimePass, setOneTimePass] = useState<OneTimePass | undefined>(undefined);
  const [oneTimePassList, setOneTimePassList] = useState<OneTimePass[]>([]);
  const [sessionKey, setSessionKey] = useState<string | undefined>(undefined);
  const [otpInfo, setOtpInfo] = useState<string | undefined>(undefined);
  const resetOtpContext = () => {
    setCount(0);
    setOneTimePass(undefined);
    setOneTimePassList([]);
    setSessionKey(undefined);
    setOtpInfo(undefined);
  };

  return (
    <OneTimePassContext.Provider
      value={{
        count,
        oneTimePass,
        oneTimePassList,
        sessionKey,
        otpInfo,
        setCount,
        setOneTimePass,
        setOneTimePassList,
        setSessionKey,
        setOtpInfo,
        resetOtpContext,
      }}
    >
      {children}
    </OneTimePassContext.Provider>
  );
};

export const useOneTimePassContext = () => {
  const context = useContext(OneTimePassContext);
  if (!context) throw new Error("OneTimePassContext must be used within OneTimePassProvider");
  return context;
};